import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row mb-2 mb-xl-3" }
const _hoisted_2 = { class: "col-auto ms-auto text-end mt-n1" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Модель"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Вид работы"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "p-2",
      colspan: "2"
    }, "Продолжительность работы в днях")
  ])
], -1)
const _hoisted_8 = { class: "p-2" }
const _hoisted_9 = { class: "p-2" }
const _hoisted_10 = { class: "p-2" }
const _hoisted_11 = { class: "p-2" }
const _hoisted_12 = { class: "p-2 text-end" }
const _hoisted_13 = {
  key: 1,
  class: "table table-bordered"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Модель", -1)
const _hoisted_15 = { class: "p-2" }
const _hoisted_16 = { class: "p-2" }
const _hoisted_17 = { class: "p-2" }

import { computed, onMounted, ref } from 'vue';
import api from '@/api';
import { useModal } from '@/composables/useModal';
import { userStore } from '@/store/userStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListEquipmentComponent',
  setup(__props) {

const list = ref([]);
const isTable = ref(0);
const { user } = userStore();

const getCurrentRate = computed(() => {
    return (item: any, r: any) => {
        let f = item.rates.find((i: any) => i.jobId === r.jobId);
        if (f) {
            return f.days;
        }

        return '-';
    };
});

const getTable = computed(() => {
    return list.value.reduce((r: any, c: any) => {
        let ind = r.findIndex((i: any) => i.modelId === c.modelId);

        if (ind === -1) {
            r.push({
                ...c,
                ...{
                    rates: [c],
                },
            });
        } else {
            r[ind].rates.push(c);
        }

        return r;
    }, []);
});

const getRates = computed(() => {
    return list.value.reduce((r: any, c: any) => {
        let ind = r.findIndex((i: any) => i.jobId === c.jobId);

        if (ind === -1) {
            r.push({
                jobId: c.jobId,
                jobName: c.jobName,
                days: c.days,
            });
        }

        return r;
    }, []);
});

onMounted(() => {
    api.rate.get().then((r) => (list.value = r.data));
});

function addRate() {
    useModal('item_equipment_modal')
        .open({
            type: 'add',
            list: list,
        })
        .then((r: any) => {
            list.value.unshift(r.item);
        });
}

function editItem(item: any) {
    useModal('item_equipment_modal')
        .open({
            type: 'edit',
            item: item,
            list: list,
        })
        .then((r: any) => {
            let ind = list.value.findIndex((i: any) => i.id === r.item.id);

            if (ind !== -1) {
                list.value[ind].modelId = r.item.modelId;
                list.value[ind].jobId = r.item.jobId;
                list.value[ind].days = r.item.days;
            }
        });
}

function deleteItem(item: any) {
    api.rate.remove(item.id).then((r: any) => {
        let ind = list.value.findIndex((i: any) => i.id === item.id);

        if (ind !== -1) {
            list.value.splice(ind, 1);
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_button_ui = _resolveComponent("button-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isTable.value === 0)
          ? (_openBlock(), _createBlock(_component_button_ui, {
              key: 0,
              "button-class": "btn-secondary me-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isTable.value = 1))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Вид 2 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isTable.value === 1)
          ? (_openBlock(), _createBlock(_component_button_ui, {
              key: 1,
              "button-class": "btn-secondary me-3",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isTable.value = 0))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Вид 1 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(user).isAdmin || _unref(user).isCentrsklad || _unref(user).isTechnologist || _unref(user).isSales || _unref(user).isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_button_ui, {
              key: 2,
              "button-class": "btn-primary",
              onClick: addRate
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!isTable.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", _hoisted_8, _toDisplayString(item.id), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(item.modelName), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(item.jobName), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(item.days), 1),
                      _createElementVNode("td", _hoisted_12, [
                        (
                                        _unref(user).isAdmin ||
                                        _unref(user).isCentrsklad ||
                                        _unref(user).isTechnologist ||
                                        _unref(user).isSales ||
                                        _unref(user).isSuperAdmin
                                    )
                          ? (_openBlock(), _createBlock(_component_button_ui, {
                              key: 0,
                              "button-class": "btn-primary btn-sm",
                              onClick: ($event: any) => (editItem(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Редактировать ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (
                                        _unref(user).isAdmin ||
                                        _unref(user).isCentrsklad ||
                                        _unref(user).isTechnologist ||
                                        _unref(user).isSales ||
                                        _unref(user).isSuperAdmin
                                    )
                          ? (_openBlock(), _createBlock(_component_button_ui, {
                              key: 1,
                              "button-class": "btn-danger btn-sm ms-3",
                              onClick: ($event: any) => (deleteItem(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Удалить ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (isTable.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRates.value, (r) => {
                      return (_openBlock(), _createElementBlock("th", _hoisted_15, _toDisplayString(r.jobName), 1))
                    }), 256))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTable.value, (item, itemInd) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.modelName), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRates.value, (r) => {
                        return (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(getCurrentRate.value(item, r)), 1))
                      }), 256))
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})